// extracted by mini-css-extract-plugin
export default {"Post":"PostPreview_Post__NtgAS","Repost":"PostPreview_Repost__4B-08","NotPublished":"PostPreview_NotPublished__-9Xwb","Delayed":"PostPreview_Delayed__rYxcl"};